var map = {
	"./anchor.svg": 97,
	"./box.svg": 98,
	"./briefcase.svg": 60,
	"./cloud.svg": 99,
	"./coffee.svg": 100,
	"./cube.svg": 101,
	"./disk.svg": 102,
	"./edit.svg": 75,
	"./gift.svg": 103,
	"./heart.svg": 104,
	"./mail.svg": 105,
	"./moon.svg": 106,
	"./profile.svg": 107,
	"./ribbon.svg": 108,
	"./star.svg": 109,
	"./sun.svg": 110
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 547;